import { SYSTEM_PATH } from '../configs/constants';

const KEY = 'student_post_login_redirect';

function isSafe(fullPath) {
    if (fullPath == null || typeof fullPath !== 'string') return false;
    const p = fullPath.trim();
    if (!p.startsWith('/') || p.startsWith('//')) return false;
    if (p === SYSTEM_PATH.LOGIN || p.startsWith(`${SYSTEM_PATH.LOGIN}?`)) return false;
    return true;
}

/** Stores pathname + search before redirecting to /login. */
export function saveRedirect(pathname, search) {
    const full = `${pathname || ''}${search == null ? '' : search}`;
    if (!isSafe(full)) return;
    try {
        sessionStorage.setItem(KEY, full);
    } catch {
        /* quota / private mode */
    }
}

/** Reads and clears the stored path; call after successful login. */
export function consumeRedirect() {
    try {
        const raw = sessionStorage.getItem(KEY);
        sessionStorage.removeItem(KEY);
        if (raw && isSafe(raw)) return raw;
    } catch {
        /* ignore */
    }
    return null;
}
